import { useForm } from 'react-hook-form';
import { useRef } from 'react';
import CrLocationField from '../search-bar/cr-location-field';

const JobSearchForm = () => {
  const searchForm = useRef();
  const { register, setValue } = useForm();

  return (
    <>
      <form
        ref={searchForm}
        action="/job-search"
        acceptCharset="UTF-8"
        className="site-search"
        method="GET"
        id="job_search"
      >
        <fieldset>
          <legend>
            Search here for your next part-time, seasonal, internship, apprenticeship, or
            entry-level job:
          </legend>

          <label className="sr-only" htmlFor="search">
            Search by job title or keywords
          </label>
          <input
            {...register('keyword')}
            className="form-control mb-lg-0 shadow-none"
            id="search"
            placeholder="Search by job title or keywords"
            type="text"
          />
          <label className="sr-only" htmlFor="location">
            Location
          </label>
          <CrLocationField
            {...{ register, setValue, searchForm }}
            className="form-control mb-lg-0 shadow-none"
            id="location"
            placeholder="Location"
            type="text"
          />
          <div className="submit fa-light fa-magnifying-glass">
            <input type="submit" value="Search" />
          </div>
        </fieldset>
        <input {...register('latitude')} type="hidden" id="latitude" value="" />
        <input {...register('longitude')} type="hidden" id="longitude" value="" />
        <input {...register('commuteFilter')} type="hidden" id="commuteFilter" value="" />
      </form>
    </>
  );
};

export default JobSearchForm;
